import { client } from 'api';
import sessionManager from './sessionManager';
import * as types from '../../mutationTypes';

// Compare to (Token Expiry - Now)
// FIXME : This will break if Token Durations drop to 15 mins
// Perhaps these should be at 25% & 10% of the Token Duration instead?
const REFRESHTOKENTHRESHOLDMS = 15 * 60 * 1000;
const INTERRUPTREFRESHTOKENTHRESHOLDMS = 5 * 60 * 1000;
// For testing purposes:
// const REFRESHTOKENTHRESHOLDMS = 3600000 - (10 * 1000);
// const INTERRUPTREFRESHTOKENTHRESHOLDMS = 3600000 - (20 * 1000);

let onlyOneRefreshPlease = null;
let onlyOneInterruptPlease = null;

export default {
    async initialize({ commit, dispatch }) {
        // FIXME: Vote to instantiate sessionManager as a singleton
        // prior to instanting Vue.  This would eliminate this...
        //
        // Careful, this does not behave synchronously with awaits in
        // our current startup sequence (login currently ok).
        // Awaits are promises, they yield to the event loop.
        // 1. The vue-router beforeEach is run before the App.vue beforeCreate
        // 2. We're currently pushing a function to the event loop in beforeEach
        // 3. That function routes back to login if user is not authenticated
        // We should probably move the sessionManager instantiation before
        // Vue is instantiated.
        // For full initialisation, we have to await discovery of the IdP

        // Do the lightweight synchronous state mutations first
        const subdomain = sessionManager.getSubdomain();
        commit(types.SET_SUBDOMAIN, subdomain);

        commit(types.SET_REDIRECT_URI, sessionManager.getIdpRedirectUrl());

        // This just returns window.location.hostname
        commit(types.SET_FQDN, sessionManager.getFQDN());

        if (sessionManager.isLoggedIn()) {
            // FIXME: We shouldn't get here if the token is expired
            sessionManager.setAuthorizationHeaderUsingLocalStorage();
            commit(types.SET_ROLE, sessionManager.getUserRoleFromLocalStorage());
            commit(types.SET_TOKEN_EXPIRY, sessionManager.getTokenExpiryFromLocalStorage());
            sessionManager.setAdditionalHeaders();

            await dispatch('getSiteType');

            const diffms = sessionManager.getTokenExpiryFromLocalStorage() -
              new Date().getTime();
            const interruptms = diffms - INTERRUPTREFRESHTOKENTHRESHOLDMS;
            if (!onlyOneInterruptPlease) {
                onlyOneInterruptPlease = setTimeout(() => {
                    // override refresh state, user has been idle
                    commit(types.SET_REFRESH_TOKEN, false);
                    commit(types.SET_INTERRUPT_REFRESH_TOKEN, true);
                    onlyOneInterruptPlease = null;
                }, interruptms);
            }
            const refreshms = diffms - REFRESHTOKENTHRESHOLDMS;
            if (!onlyOneRefreshPlease) {
                onlyOneRefreshPlease = setTimeout(() => {
                    commit(types.SET_REFRESH_TOKEN, true);
                    onlyOneRefreshPlease = null;
                }, refreshms);
            }

            dispatch('loadModules', null, { root: true });
        }
        // Do async mutations last, we only need idp for login/token refreshn
        const { idpUri } = await sessionManager.init();
        commit(types.SET_IDP_URI, idpUri);
    },

    async login({ commit, dispatch, state }, details) {
        // Make sure to re-initialize the state as the redirect will cause
        // a page reload.
        dispatch('logout');

        // Now we initialize knowing we're not logged in
        await dispatch('initialize');

        // Then make sessionManager.isLoggedIn() return true
        sessionManager.saveToken(details.uri);
        sessionManager.setAuthorizationHeader(details.uri);
        sessionManager.saveOriginalAdminRole(null);
        const userRole = await sessionManager.getUserRole(state.idpUri);
        if (userRole > 0) {
            sessionManager.saveUserRole(userRole);
            await dispatch('initialize');
        } else {
            dispatch('logout');
            throw new Error('Unable to retrieve user role, is the network/IdP down?');
        }
    },

    async refresh({ commit, dispatch, state }, details) {
        // Then make sessionManager.isLoggedIn() return true
        // No need to interrupt, we've refreshed silently
        commit(types.SET_INTERRUPT_REFRESH_TOKEN, false);

        dispatch('clearTokenTimeouts');
        sessionManager.saveToken(details.uri);
        sessionManager.setAuthorizationHeader(details.uri);
        const userRole = await sessionManager.getUserRole(state.idpUri);
        if (userRole > 0) {
            sessionManager.saveUserRole(userRole);
            commit(types.SET_ROLE, sessionManager.getUserRoleFromLocalStorage());
            commit(types.SET_TOKEN_EXPIRY, sessionManager.getTokenExpiryFromLocalStorage());

            const diffms = sessionManager.getTokenExpiryFromLocalStorage() -
              new Date().getTime();
            const interruptms = diffms - INTERRUPTREFRESHTOKENTHRESHOLDMS;
            if (!onlyOneInterruptPlease) {
                onlyOneInterruptPlease = setTimeout(() => {
                    // override refresh state, user has been idle
                    commit(types.SET_REFRESH_TOKEN, false);
                    commit(types.SET_INTERRUPT_REFRESH_TOKEN, true);
                    onlyOneInterruptPlease = null;
                }, interruptms);
            }
            const refreshms = diffms - REFRESHTOKENTHRESHOLDMS;
            if (!onlyOneRefreshPlease) {
                onlyOneRefreshPlease = setTimeout(() => {
                    commit(types.SET_REFRESH_TOKEN, true);
                    onlyOneRefreshPlease = null;
                }, refreshms);
            }
        } else {
            dispatch('logout');
            throw new Error('Unable to retrieve user role, is the network/IdP down?');
        }
    },

    clearTokenTimeouts({ commit, dispatch }) {
        if (onlyOneRefreshPlease) {
            window.clearTimeout(onlyOneRefreshPlease);
            onlyOneRefreshPlease = null;
        }
        if (onlyOneInterruptPlease) {
            window.clearTimeout(onlyOneInterruptPlease);
            onlyOneInterruptPlease = null;
        }
    },

    logout({ commit, dispatch }) {
        dispatch('clearTokenTimeouts');
        sessionManager.clear();
        commit(types.SET_ROLE, 0);
        commit(types.APPEARANCE_RESET_ALERT, null, { root: true });
    },

    async getSiteType({ commit }) {
        const clientResult = await client.getClient();
        const children = await client.getClientChildren();
        if (clientResult.data.parentId !== null) {
            commit(types.SET_SITE_TYPE, 2); // Child School Site in Group
        } else if (children.data.length > 0) {
            commit(types.SET_SITE_TYPE, 3); // Enterprise Group Site
        } else {
            commit(types.SET_SITE_TYPE, 1); // Single School Site
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/session/actions.js